<template>
  <Head :title="t('page.title')"></Head>
  <div class="bg-gradient-to-b from-blue-50 via-transparent to-transparent">
    <!-- Admin login link -->
    <s-btn
      :href="route('login')"
      color="primary-white"
      icon="account"
      class="absolute top-0 right-0 !bg-transparent hover:!bg-white/70 focus:!bg-white/70 !border-r-0 !border-t-0 !rounded-none !rounded-bl-xl"
    >
      {{ t('links.customerLogin') }}
    </s-btn>
    <div class="p-4 lg:p-8 max-w-xl mx-auto flex flex-col gap-5">
      <!-- Because this will redirect to Microsoft, we need to ensure the form uses an actual post instead of AJAX -->
      <form
        aria-labelledby="form-title"
        method="POST"
        :action="route('auth.microsoft.redirect')"
        class="flex flex-col shadow-card rounded-lg"
      >
        <input type="hidden" name="_token" :value="csrfToken" />

        <h1
          id="form-title"
          class="bg-gradient-to-t from-white/70 to-white/30 flex items-center justify-center p-6 rounded-t-lg border border-white/50 border-b-gray-100"
        >
          <s-logo type="image" class="logo h-16 lg:h-[4.5rem] w-auto" />
          <span class="sr-only">
            {{ t('page.title') }}
          </span>
        </h1>
        <div
          class="px-5 lg:px-8 py-5 lg:py-8 bg-gradient-to-t from-gray-50 to-white rounded-b-lg flex flex-col gap-5"
        >
          <s-btn type="submit" color="primary" icon="microsoft">
            {{ t('actions.login') }}
          </s-btn>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup lang="ts">
import {Head} from '@inertiajs/vue3';
import {useI18n} from 'vue-i18n';
import {route} from 'ziggy-js';
import SBtn from '../../../design-system/SBtn.vue';
import SLogo from '../../../design-system/SLogo.vue';
import SIcon from '../../../design-system/SIcon.vue';
import SLink from '../../../components/SLink.vue';
import UnauthorizedLayout from '../../../layouts/UnauthorizedLayout.vue';

defineOptions({layout: UnauthorizedLayout});

const {t} = useI18n();
defineProps<{
  csrfToken: string;
}>();
</script>
<i18n>
{
  "en": {
    "page.title": "Stemble Admin Login",
    "actions.login": "Login with Microsoft",
    "links.customerLogin": "Customer Login"
  },
  "fr": {
    "page.title": "Connexion Admin Stemble",
    "actions.login": "Connexion avec Microsoft",
    "links.customerLogin": "Connexion Client"
  }
}
</i18n>
